import React from 'react'
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import TripBasicInfoComponent from './trip-basic-info.component';
import StopsInfoComponent from './stops-info.component';
import TasksInfoComponent from './task-info.component';

export default function TripComponent({ tasksDetails, libraryData, stopDetails, transporters, agents, mediaFiles, handleFormMediaItemChange, fileTypes, changeImage, orderDetails, handleShipmentStatusClick, handleMenuClose, handleRejectOpen, anchorShipmentEl, setAnchorShipmentEl, back, tripsDetails, getShippingType, getTransporterAgentName, handleShipmentClick, ConvertMinutes }: any) {

    const tabItems = [
        {
            id: 1,
            title: 'Basic Info',
            component: <TripBasicInfoComponent
                agents={agents}
                transporters={transporters}
                orderDetails={orderDetails}
                tripsDetails={tripsDetails}
                getShippingType={getShippingType}
                ConvertMinutes={ConvertMinutes} />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'stops Info',
            component: <StopsInfoComponent
                libraryData={libraryData}
                stopDetails={stopDetails} />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Task Info',
            component: <TasksInfoComponent
                libraryData={libraryData}
                tasksDetails={tasksDetails}
            />,
            isVisible: true,
        },
        // {
        //     id: 4,
        //     title: 'Media',
        //     component:
        //         <MediaInfoComponent
        //             changeImage={changeImage}
        //             // deleteSelectedProduct={deleteSelectedCategory}
        //             fileTypes={fileTypes}
        //             //handleClose={handleClose}
        //             //handleOpen={handleOpen}
        //             onFormItemChange={handleFormMediaItemChange}
        //             // openConfirmation={openConfirmation}
        //             mediaFiles={mediaFiles}
        //         //uploadToDigiiFolder={uploadToDigiiFolder}
        //         />,
        //     isVisible: true,
        // },

    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>

            </div>
        </div>
    )
}